import React from 'react';
import { observer } from '@poa/state';

const FilterBadge = observer(
  class extends React.Component {
    onRemove = () => {
      this.props.onRemove(this.props.filter.type, this.props.filter.value);
    };

    render() {
      const { filter } = this.props;

      return (
        <button className="table-container__filter-btn table-filter-btn" onClick={this.onRemove}>
          {filter.label}: {filter.value}
          <svg className="icon icon-cross" viewBox="0 0 15 16">
            <path d="M16 8.63H9.17V15H6.79V8.63H0v-2.3h6.79V0h2.42v6.33H16z" />
          </svg>
        </button>
      );
    }
  }
);

export const DataTableFilters = observer(({ filters, onRemove }) => {
  if (typeof filters === 'undefined') {
    return (
      <div className="table-container__filters"></div>
    );
  } else {
    return (
      <div className="table-container__filters">
        {filters.map(filter => (
          <FilterBadge
            key={`filter-badge-${filter.type}-${filter.value}`}
            filter={filter}
            onRemove={onRemove}
          />
        ))}
      </div>
    );
  }
  });
